/* AMADEUS CARTLAG1 (2026-10-21): a visible waiting state on a cart line while Shopify answers a
   quantity change. The theme (Prestige, theme.js: LineItemQuantity) sends the change at once and
   shows nothing on the line until the drawer is re-rendered, about 1.5 seconds in the beta
   (Jordan, Oct 16: "I had to press several times before I realized it was just slow"). The theme
   dispatches line-item:will-change on the line before the request and line-item:change after it,
   and theme:loading:end after either outcome; this listens to those and touches nothing else.
   Loaded by layout/theme.liquid. Parsed with node --check before every push (CLAUDE.md item 67). */
(function () {
  'use strict';
  var CLASS = 'amadeus-waiting';
  var style = document.createElement('style');
  style.textContent =
    'line-item.' + CLASS + ' { opacity: .55; pointer-events: none; transition: opacity .15s ease; }' +
    'line-item.' + CLASS + ' line-item-quantity { position: relative; }' +
    'line-item.' + CLASS + ' line-item-quantity::after { content: "Updating…"; margin-left: 8px; ' +
    'font-size: 12px; line-height: 1.6; color: rgb(var(--text-color, 0 0 0) / .7); white-space: nowrap; align-self: center; }';
  document.head.appendChild(style);

  function lineOf(target) {
    if (!target || !target.closest) return null;
    return target.closest('line-item');
  }
  function wait(line) {
    if (!line) return;
    line.classList.add(CLASS);
    line.setAttribute('aria-busy', 'true');
  }
  function clear(line) {
    if (!line) return;
    line.classList.remove(CLASS);
    line.removeAttribute('aria-busy');
  }
  document.addEventListener('line-item:will-change', function (e) { wait(lineOf(e.target)); });
  document.addEventListener('line-item:change', function (e) { clear(lineOf(e.target)); });
  document.addEventListener('theme:loading:end', function () {
    var lines = document.querySelectorAll('line-item.' + CLASS);
    for (var i = 0; i < lines.length; i++) clear(lines[i]);
  });
})();
